<template>
  <el-form
    :label-width="labelWidth"
    class="el-form ccui-form dic-ccui-form-biserial"
  >
    <el-row>
      <el-col
        v-for="(item, index) in fieldList"
        :key="item.fieldName + index"
        :span="item.filedSpan || 12"
      >
        <el-form-item :label="`${item.label}：`">
          <template v-if="item.filedSpan === 24">
            <el-tooltip
              placement="top"
              effect="light"
              :content="dataInfo[item.fieldName]"
              v-showellipsistip
            >
              <span class="vtip-text-ellipsis-3">
                {{ dataInfo[item.fieldName] }}
              </span>
            </el-tooltip>

            <!--            <div class="ellipsis-3">-->
            <!--              {{ dataInfo[item.fieldName] }}-->
            <!--            </div>-->
          </template>
          <template v-else>
            <div
              class="vtip-text"
              v-if="item.slot === 'factCapl' || item.slot === 'regCapl'"
            >
              <el-tooltip
                placement="top"
                effect="light"
                :content="
                  dataInfo[item.fieldName] === ''
                    ? '0'
                    : dataInfo[item.fieldName] | bigNumberFormat(2)
                "
                v-showtip
              >
                <span class="vtip-text">{{
                  dataInfo[item.fieldName] === ""
                    ? "0"
                    : dataInfo[item.fieldName] | bigNumberFormat(2)
                }}</span>
                <!-- dataInfo[item.fieldName] === ""
                    ? ""
                    : dataInfo[item.fieldName] % 1 === 0
                    ? dataInfo[item.fieldName] + ".00"
                    : dataInfo[item.fieldName] -->
                <!-- 未使用公共根式化之前的判断逻辑 -->
              </el-tooltip>
            </div>
            <div v-else>
              <el-tooltip
                placement="top"
                effect="light"
                :content="dataInfo[item.fieldName]"
                v-showtip
              >
                <span class="vtip-text">{{ dataInfo[item.fieldName] }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: "basicInfo",
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    fieldList: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    labelWidth: {
      type: String,
      default: "163px"
    }
  }
};
</script>

<style scoped lang="scss">
.vtip-text {
  width: 100%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 30px;
}
.vtip-text-ellipsis-3 {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
